import React from 'react'
import SharedHeader from '../Shared/SharedHeader'
import ContactForm from './ContactForm'
import GoogleMap from './GoogleMap'
import useHomepage from '../../hooks/useHomepage'

const Contact = () => {
  
  const { data, loading, error } = useHomepage(); // 👈 fetch from Redux store

  if (loading) return <div>Loading homepage...</div>;
  if (error) return <div>Error loading homepage: {error}</div>;
  return (
    <div>
      <SharedHeader title={'Contact Us'} data={data?.contact_us?.main?.photos} />
      <ContactForm />
      <GoogleMap />

    </div>
  )
}

export default Contact